"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DeleteConfirmationDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _useTranslations = require("../../../../hooks/useTranslations");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DeleteConfirmationDialog = (param)=>{
    let { onConfirmation, onCancel, isOpen } = param;
    const { translations } = (0, _useTranslations.useTranslations)();
    const actions = (0, _react.useMemo)(()=>[
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                color: "primary",
                variant: "contained",
                onClick: onCancel,
                children: translations.deletionDialogCancelBtn
            }, "no"),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.Button, {
                color: "default",
                variant: "text",
                onClick: onConfirmation,
                children: translations.deletionDialogOkBtn
            }, "yes")
        ], [
        onCancel,
        onConfirmation,
        translations.deletionDialogCancelBtn,
        translations.deletionDialogOkBtn
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
        severity: "error",
        open: isOpen,
        header: translations.deletionDialogTitle,
        actions: actions,
        onClose: onCancel,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Content, {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Typography, {
                children: translations.deletionDialogText
            })
        })
    });
};
exports.DeleteConfirmationDialog = DeleteConfirmationDialog;
